import { CREATORLAND_TWITTER_USERNAME } from '@/shared/consts/pages'
import Head from 'next/head'
import React from 'react'
import { environment } from '../shared/consts/environment'

interface Props {
  children?: React.ReactNode
  title?: string
  description?: string
  image?: string
  twitterDescription?: string
  twitterImage?: string
  canonicalPath?: string
}

export const MainLayout: React.FC<Props> = ({
  children,
  twitterDescription,
  twitterImage = '/assets/images/cratorland-default-twitter.png',
  title = 'Creatorland',
  description = 'Creatorland is a professional networking platform for the creator economy. Join creators, marketers, talent managers, and other creative professionals.',
  image = `/assets/images/creatorland-welcome-card.jpg`,
  canonicalPath,
}) => {
  const tDescription = twitterDescription || description
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        {/* social meta tags */}
        <meta name="twitter:card" content="summary" key="head_twitter_card" />
        <meta
          name="twitter:site"
          content={CREATORLAND_TWITTER_USERNAME}
          key="head_twitter_site"
        />
        <meta
          name="twitter:creator"
          content={CREATORLAND_TWITTER_USERNAME}
          key="head_twitter_creator"
        />
        <meta name="twitter:title" content={title} key="head_twitter_title" />
        <meta
          name="twitter:description"
          content={tDescription}
          key="head_twitter_description"
        />
        <meta
          name="twitter:image"
          content={twitterImage}
          key="head_twitter_image"
        />
        <meta
          name="twitter:image:alt"
          content={tDescription}
          key="head_twitter_image_alt"
        />
        {/* open graph meta tags */}
        <meta property="og:title" content={title} key="head_og_title" />
        <meta
          property="og:description"
          content={description}
          key="head_og_description"
        />
        <meta property="og:image" content={image} key="head_og_image" />
        <meta
          property="og:url"
          content={environment.appUrl}
          key="head_og_url"
        />
        <meta property="og:type" content="website" key="head_og_type" />
        <meta
          property="og:site_name"
          content="Creatorland"
          key="head_og_site_name"
        />
        <meta property="og:locale" content="en_US" key="head_og_locale" />
        <meta
          property="og:locale:alternate"
          content="en_US"
          key="head_og_locale_alternate"
        />
        {/* SEO Tags */}
        {canonicalPath && (
          <link
            rel="canonical"
            href={`${environment.appUrl}${canonicalPath}`}
          />
        )}
      </Head>
      <div>{children}</div>
    </>
  )
}
